module.exports = __webpack_public_path__ + "6252070536bdf5830a53ff68a18c9762.svg";